<template>
  <div class="relative flex">
    <div
      v-if="disabled"
      :class="[disabled ? 'z-20' : '', 'flex absolute bg-transparent inset-0 rounded-full cursor-not-allowed']"
      @click="onHandleSwitchClick"
    />
    <Switch
      v-model="isEnabled"
      :disabled="disabled"
      :class="[bgColor ? bgColor : isEnabled ? switchType : unPressedBgColor ? unPressedBgColor : 'bg-grayCust-160', switchSize, 
               disabled ? 'z-10' : '',
               ' relative inline-flex flex-shrink-0 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-0 focus:ring-4 focus:ring-primary-275 disabled:border-grayCust-160 disabled:cursor-not-allowed']"
      @update:model-value="updateValue"
    >
      <span
        aria-hidden="true"
        :class="[isEnabled ? extraClass : 'translate-x-0', switchRound, switchRoundColor, 'flex items-center justify-center pointer-events-none rounded-full shadow transform ring-0 transition ease-in-out duration-200']"
      >
        <component
          :is="iconComponent(iconType, pressedIcon)"
          v-if="!isEnabled && pressedIcon"
          :class="switchImageSize"
        />
        <component
          :is="iconComponent(iconType, unPressedIcon)"
          v-else
          :class="[iconColor ? iconColor : iconStyle, switchImageSize]"
        />
      </span>
    </Switch>
  </div>
</template>

<script>
import { Switch } from '@headlessui/vue';
import * as OutlineIcons from "@heroicons/vue/outline";
import * as SolidIcons from "@heroicons/vue/solid";

export default {
    name:'ToggleSwitch',
    components: {
        Switch
    },
    props:{
        pressedIcon: String,
        unPressedIcon: String,
        iconColor: String,
        bgColor: String,
        unPressedBgColor:String,
        modelValue: {
            type: Boolean,
            default: false,
            required: false
        },
        disabled: {
            type: Boolean,
            default: false,
            required: false
        },
        type: {
            type: String,
            default: 'secondary',
            required: false
        },
        
        size: {
            type: String,
            default: 'switch-sm',
            required: false
        },
       
        iconType:{
            type: String,
            required: false,
            default: 'outline'
        },
    },
    data(){
        return{
            switchType: null,
            switchSize: null,
            switchImageSize:null,
            switchRound:'w-4 h-4',
            switchRoundColor:'bg-white',
            extraClass:null,
            iconStyle: null,
            isEnabled: this.modelValue
        }
    },
    watch: {
        modelValue(val) {
            this.isEnabled = val;
        }
    },
    created(){
        switch(this.type){
            case 'primary':
                this.switchType = 'bg-primary-900'
                this.iconStyle = 'text-primary-900'
                break;
            case 'secondary':
                this.switchType = 'bg-secondary-800'
                this.iconStyle = 'text-secondary-800'
                break;
            case 'danger':
                this.switchType = 'bg-redCust-730'
                this.iconStyle = 'bg-redCust-730'
                break;
            case 'default':
                this.switchType = 'bg-grayCust-280'
                this.switchRoundColor = 'bg-grayCust-380'
                break;
        }

        switch(this.size){
            case 'switch-sm':
                this.switchSize = 'w-9 h-5'
                this.switchRound = 'w-4 h-4'
                this.extraClass = 'translate-x-4'
                this.switchImageSize = 'w-2.5 h-2.5'
                break;
            case 'switch-lg':
                this.switchSize = 'w-11 h-6'
                this.switchRound = 'w-5 h-5'
                this.extraClass = 'translate-x-5'
                this.switchImageSize = 'w-3.5 h-3.5'
                break;
        }
    },
    methods:{
        iconComponent(type, iconName) {
          switch (type) {
            case "solid":
                if (Object.prototype.hasOwnProperty.call(SolidIcons, iconName)) {
                    return SolidIcons[iconName];
                } else {
                    return null;
                }
            case "outline":
                if (Object.prototype.hasOwnProperty.call(OutlineIcons, iconName)) {
                    return OutlineIcons[iconName];
                } else {
                    return null;
                }
            default:
            return null;
          }
        },
        updateValue(value) {
            this.isEnabled = value;
            this.$emit('update:modelValue', value);
        },
        onHandleSwitchClick() {
            this.$emit('onHandleSwitchClick');
        }
    }
}

</script>
